import { useTranslation } from 'next-i18next'
// Libs
import React, { useEffect } from 'react'
import styled from 'styled-components'

// Comps
import { Modal, Props as ModalProps } from './Modal'
import { H5, P, H3 } from '../Headings'
import { fadeIn } from '../../utils/keyframes'
import {
  ModalMultiContentWrapper,
  ModalMultiContent,
} from './ModalContentWrapper'
import { colors, fontWeights, icons } from '../../utils'
import { Hyperlink } from '../Hyperlink'
import { CTA } from '../CTA'

// Styles
import {
  paymentSuccessDivStyles,
  paymentSuccessNotificationStyles,
} from './paymentSuccessModalStyles'

const ModalContentWrapper = styled(ModalMultiContentWrapper)``
const PaymentSuccessDiv = styled(ModalMultiContent)`
  ${paymentSuccessDivStyles}
`
const PaymentSuccessNotification = styled(ModalMultiContent)`
  ${paymentSuccessNotificationStyles}
`

// Defs
interface Props extends ModalProps {
  showCalendarClick: () => void
  showPaymentSuccessNotification: boolean
  closePaymentSuccessNotification: () => void
}

export const PaymentSuccessModal: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // Props.
  const {
    showCalendarClick,
    closePaymentSuccessNotification,
    showPaymentSuccessNotification,
    close,
  } = props

  // Funcs
  const autoClosePaymentSuccessModal = () => {
    setTimeout(() => closePaymentSuccessNotification(), 8000)
  }

  useEffect(() => {
    autoClosePaymentSuccessModal()
  }, [])

  // ..
  return (
    <Modal close={close}>
      {/* Multiple Modal Container */}
      <ModalContentWrapper>
        {/* Main modal */}
        <PaymentSuccessDiv>
          <H3 className="header">
            {t(`PaymentSuccessModal-2140632099`, `You’re going to this event!`)}
          </H3>
          <H5 className="content">
            {t(
              `PaymentSuccessModal-1147647854`,
              `We’ll send you reminder emails leading up to the event, including right beforehand with a direct link to the video call.`,
            )}
            <br />
            <br />
            {t(
              `PaymentSuccessModal451999030`,
              `In the meantime, ensure to save it to your calendar!`,
            )}
          </H5>
          {/* Add to calendar Button. */}
          <CTA
            className="purple button addToCalendarButton"
            onClick={showCalendarClick}>
            {t(`PaymentSuccessModal-772917915`, `Add to your calendar`)}
          </CTA>
          {/* Back Button. */}
          <CTA className="button closeButton" onClick={close}>
            {t(`Close`, `Close`)}
          </CTA>
        </PaymentSuccessDiv>

        {/* Stripe info toast that's using the toast system */}
        {showPaymentSuccessNotification === true && (
          <>
            <PaymentSuccessNotification>
              <div
                className="closeDiv"
                onClick={closePaymentSuccessNotification}>
                <img src={icons.closeGrey}></img>
              </div>
              <H5 className="header">
                {t(
                  `PaymentSuccessModal-1226387031`,
                  `🎉 Payment for the event was successful!`,
                )}
              </H5>
              <P className="detail">
                {t(
                  `PaymentSuccessModal-1553348076`,
                  `For terms, refunds and conditions please`,
                )}
                <Hyperlink className="link" href="/terms" newTab={true}>
                  {' '}
                  {t(`click here`, `click here`)}
                </Hyperlink>
              </P>
            </PaymentSuccessNotification>
          </>
        )}
      </ModalContentWrapper>
    </Modal>
  )
}
